exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove[data-v-667c566d]{height:24px;width:24px;background-color:red;border-radius:50%;color:#fff;margin-left:4px;cursor:pointer}.total-working-hours input[data-v-667c566d]{max-width:176px;margin-right:8px}.total-working-hours i[data-v-667c566d]{font-size:24px}.project-total-working-hours[data-v-667c566d]{display:flex;align-items:center}.fa[data-v-667c566d]{cursor:pointer}.text-bold[data-v-667c566d]{font-weight:700}", ""]);

// exports
